import { SurveySegment } from ".";


export type PublicLinkObjectType = typeof PublicLinkObjectTypes[number];
export const PublicLinkObjectTypes = ['surveyReport', 'actionPlan'] as const;

// All actionplan related links are stored as actionplan link configurations,
// to make it easy to search for all links related to an action plan.
export type ActionPlanLinkConfiguration = 
    { type:'actionPlan', writeable:boolean } |
    { type:'actionPlanTopic', topicId:string, writeable:boolean } |
    { type:'actionPoint', actionPointId:string, writeable:boolean }

export type PublicActionPlanLink =
{
    id:string, // used as key in url
    objectId:string, // actionPlanId
    objectType: Extract<PublicLinkObjectType, 'actionPlan'>,
    configuration: ActionPlanLinkConfiguration,
    recipients: string[]
}

export type PublicSurveyReportLink =
{
    id:string, // used as key in url
    objectId:string // surveyId. SurveyReportId is not used, since they are constantly recreated
    objectType: Extract<PublicLinkObjectType, 'surveyReport'>
    configuration: {
        segmentFilter:SurveySegment[][]
    },
    recipients: string[]
}

export type PublicLink = 
    PublicSurveyReportLink |
    PublicActionPlanLink;

